// Package imports
import React, { useState, useEffect } from "react";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Slide from '@mui/material/Slide';
import { makeStyles } from "@material-ui/core/styles";

// JSX template  
const SecondaryModal = (props) => {
    const containerRef = React.useRef(null);
    const classes = useStyles();


    //State
    const [open, setOpen] = useState(false);
    const [noOfIteration, setNoOfIteration] = useState('1');
    const [selectedEnum, setSelectedEnum] = useState(null);

    useEffect(() => {
        setOpen(props.visible);
        setNoOfIteration('1');
        if (props.defaultSelected) {
            setSelectedEnum(props.defaultSelected.value);
        }
    }, [props.visible]);

    const handleSateLift = () => {
        let currentOptionObj = props.options.find((o) => o.value === selectedEnum);
        if (props.isUpdateEnum) {
            props.onPressUpdate(currentOptionObj);
        } else {
            props.onPressSave(noOfIteration, currentOptionObj);
        }
    };
    const handleChange = (event) => {
        setSelectedEnum(event.target.value);
    };
    const handleClose = () => {
        setOpen(false);
    };


    return (
        <Box>
            <Modal
                open={open}
                onClose={handleClose}
            >
                <Slide direction="up" in={open} container={containerRef.current}>
                <Box className={classes.Modal}>
                    {props.title && (
                        <Typography sx={{ fontWeight: '800', fontSize: '1.4rem', mt: 2, mx: 2,'@media (min-width: 1636px)': {fontSize: '2rem'}  }}>
                            {props.title}
                        </Typography>
                    )}
                    <hr />
                    <Box sx={{ textAlign: 'center' }}>
                        <Select
                            value={selectedEnum}
                            onChange={handleChange}
                            sx={{ mt: 2, color: "primary.main", backgroundColor: '#FFFFFF', borderRadius: 10, width: '70%', textAlign: 'left','@media (min-width: 1636px)': {fontSize: '1.4rem',width: '100%'} }}
                            variant="outlined"
                            disableUnderline

                        >
                            {props.options &&
                                props.options.map((obj, ind) => {
                                    return (
                                        <MenuItem sx={{ color: 'primary.main', fontWeight: '500','@media (min-width: 1636px)': {fontSize: '1.2rem'} }} value={obj.value}>{obj.text}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </Box>
                    {(props.isUpdateEnum == false) &&
                        <Box sx={{ pt: 2, textAlign: 'center' }}>
                            <Typography  sx={{textAlign: 'left', pl: 10,'@media (min-width: 1636px)': {fontSize: '1.4rem',pl:0} }}>
                                No Of Iteration
                            </Typography>
                            <TextField
                                fullWidth
                                onInput={(event) => { setNoOfIteration(event.target.value) }}
                                value={noOfIteration}
                                maxLength={2}
                                keyboardType="numeric"
                                sx={{ backgroundColor: "#F5F5F5", borderRadius: 50, width: '70%' ,'@media (min-width: 1636px)': {fontSize: '1.4rem',width: '100%'} }}
                                InputProps={{
                                    inputProps: { sx: { fontSize: "0.8rem", color: "#DB8829",'@media (min-width: 1636px)': {fontSize: '1.4rem'} } },
                                    style: { borderRadius: 50 },
                                }}
                            >
                            </TextField>
                            
                        </Box>
                    }

                    <Grid item sx={{ textAlign: "center", mt: 3 }}>
                        <Button onClick={handleSateLift} color="success" variant="contained"
                            fullWidth
                            sx={{
                                borderRadius: 10,
                                backgroundColor: "primary.success",
                                color: "#FFF",
                                fontWeight: "bold",
                                mt: 3,
                                px: 2,
                                width: '15em' ,'@media (min-width: 1636px)': {fontSize: '1.4rem', width: '100%'}
                            }}>
                            Save
                        </Button>
                    </Grid>
                    <Grid item sx={{ textAlign: "center" }}>
                        <Button onClick={() => { props.toggleModal(false); }} variant="contained"
                            fullWidth
                            sx={{
                                borderRadius: 10,
                                border: 1,
                                borderColor: "#FFFFFF",
                                color: "#FFF",
                                fontWeight: "bold",
                                mt: 2,
                                px: 2,
                                width: '15em','@media (min-width: 1636px)': {fontSize: '1.4rem', width: '100%'}
                            }}>
                            Cancel
                        </Button>
                    </Grid>
                </Box>
                </Slide>
            </Modal>
        </Box>
    );
}

const useStyles = makeStyles({
    Modal: {
        position: 'absolute',
        top: '15%',
        left: '40%',
        height: 'auto',
        transform: 'translate(-50%, -50%)',
        width: 400,
        backgroundColor: '#DB8829',
        boxShadow: 24,
        color: '#FFFFFF',
        borderRadius: 30,
        padding: 20,
    }
})
export default SecondaryModal;